import { useTranslation } from "react-i18next";

function Summary() {
  const { t } = useTranslation();
  return <span>{t("intro")}</span>;
}

export default Summary;
